/* ============================================
   AUTH UTILITIES - Secure Token Management
   ============================================ */

const TOKEN_KEY = '_wmx_auth_tk';
const USER_KEY = '_wmx_auth_usr';
const SESSION_START = '_wmx_sess_start';

/**
 * Simple XOR obfuscation for localStorage values
 * NOTE: In production, use proper encryption or httpOnly cookies
 */
function obfuscate(str, key = 'wormatrix-secret-key-2026') {
  let result = '';
  for (let i = 0; i < str.length; i++) {
    result += String.fromCharCode(str.charCodeAt(i) ^ key.charCodeAt(i % key.length));
  }
  return btoa(result);
}

function deobfuscate(encoded, key = 'wormatrix-secret-key-2026') {
  try {
    const str = atob(encoded);
    let result = '';
    for (let i = 0; i < str.length; i++) {
      result += String.fromCharCode(str.charCodeAt(i) ^ key.charCodeAt(i % key.length));
    }
    return result;
  } catch {
    return null;
  }
}

export function storeAuth(token, user) {
  try {
    localStorage.setItem(TOKEN_KEY, obfuscate(token));
    localStorage.setItem(USER_KEY, obfuscate(JSON.stringify(user)));
    localStorage.setItem(SESSION_START, Date.now().toString());
    return true;
  } catch {
    return false;
  }
}

export function getAuth() {
  try {
    const tokenEnc = localStorage.getItem(TOKEN_KEY);
    const userEnc = localStorage.getItem(USER_KEY);
    if (!tokenEnc || !userEnc) return null;
    const token = deobfuscate(tokenEnc);
    const user = JSON.parse(deobfuscate(userEnc));
    return { token, user };
  } catch {
    clearAuth();
    return null;
  }
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(SESSION_START);
}

export function isSessionValid() {
  const start = localStorage.getItem(SESSION_START);
  if (!start) return false;
  const timeout = parseInt(process.env.REACT_APP_SESSION_TIMEOUT || '3600000', 10);
  return Date.now() - parseInt(start, 10) < timeout;
}

export function generateToken(username) {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).substring(2, 10);
  const hash = btoa(`${username}:${timestamp}:${random}`);
  return `wmx_${hash}`;
}
